import React, { useState } from 'react';
import { Form, Input, Button, Typography, message, Result } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { forgotPassword } from './authApi';

const { Title, Text } = Typography;

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await forgotPassword(values.email);
      setSent(true);
    } catch (_) {
      message.success('If that email exists, a reset link has been sent.');
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="df-auth-shell">
        <div className="df-auth-panel">
          <div className="df-auth-panel__inner">
            <Result
              status="success"
              title="Check your email"
              subTitle="If that email is registered, you'll receive a password reset link shortly."
            />
            <div style={{ textAlign: 'center' }}>
              <Link to="/login" style={{ fontWeight: 600, color: 'var(--df-primary)' }}>Back to sign in</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="df-auth-shell">
      <div className="df-auth-panel">
        <div className="df-auth-panel__inner">
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <div className="df-brand df-brand--dark" style={{ justifyContent: 'center', marginBottom: 18 }}>
              <span className="df-brand__mark" aria-hidden="true">DF</span>
              <span className="df-brand__wordmark">DealFusion</span>
            </div>
            <Title level={3} style={{ margin: 0, fontFamily: 'var(--df-font-display)' }}>Reset password</Title>
            <Text style={{ display: 'block', marginTop: 6, color: 'var(--df-text-secondary)' }}>
              Enter your email and we&apos;ll send a reset link.
            </Text>
          </div>

          <Form layout="vertical" onFinish={handleSubmit} size="large" requiredMark={false}>
            <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
              <Input
                prefix={<MailOutlined style={{ color: 'var(--df-text-muted)' }} />}
                placeholder="you@email.com"
                style={{ borderRadius: 8, height: 44 }}
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              style={{
                borderRadius: 8,
                height: 46,
                fontWeight: 600,
                background: 'var(--df-accent)',
                borderColor: 'var(--df-accent)',
              }}
            >
              Send reset link
            </Button>
          </Form>

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Link to="/login" style={{ fontWeight: 600, color: 'var(--df-primary)' }}>Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
